import { DocumentType } from './DocumentType';

export const JokerTypes = {
  SOURCELIST: 'SOURCELIST',
  PRODUCTION: 'PRODUCTION',
  RESOURCEONE: 'RESOURCEONE',
  ITEM: 'ITEM',
  PROJECT: 'PROJECT',
  COMPLAINT: 'COMPLAINT',
  EMPLOYEE: 'EMPLOYEE',
  COMPANY: 'COMPANY',
};

export const JokerUngroupedOption = {
  label: 'Sorszintű',
  value: -1,
};

export const JokerTypeList = [
  { label: 'Forrásjegyzék', value: JokerTypes.SOURCELIST },
  { label: 'Gyártás', value: JokerTypes.PRODUCTION },
  { label: 'Erőforrás 1', value: JokerTypes.RESOURCEONE },
  { label: 'Cikkek', value: JokerTypes.ITEM },
  { label: 'Projekt', value: JokerTypes.PROJECT },
  { label: 'Reklamáció kezelés', value: JokerTypes.COMPLAINT },
  { label: 'Dolgozók', value: JokerTypes.EMPLOYEE },
  { label: 'Üzleti partnerek', value: JokerTypes.COMPANY },
  //bizonylatok a felületen kerülnek az autocompletebe
];

export const JokerFieldTypes = {
  TEXT: 'text',
  SELECT: 'select',
  NUMBER: 'number',
  DATE: 'date',
};

export const JokerFieldShortNames = {
  CHAR: 'CHAR',
  INT: 'INT',
  NUM: 'NUM',
  DATE: 'DATE',
};

export const JokerFieldShortNamePrefix = {
  [JokerFieldShortNames.CHAR]: 'joker_char',
  [JokerFieldShortNames.DATE]: 'joker_date',
  [JokerFieldShortNames.NUM]: 'joker_num',
  [JokerFieldShortNames.INT]: 'joker_int',
};

export const JokerFieldsCountByType = {
  [JokerTypes.SOURCELIST]: {
    [JokerFieldShortNames.CHAR]: 25,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 7,
    ROWS: {
      [JokerFieldShortNames.CHAR]: 1,
      [JokerFieldShortNames.NUM]: 2,
    },
  },
  [JokerTypes.PRODUCTION]: {
    [JokerFieldShortNames.CHAR]: 28,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 9,
    ROWS: {
      [JokerFieldShortNames.CHAR]: 2,
      [JokerFieldShortNames.NUM]: 2,
    },
  },
  [JokerTypes.RESOURCEONE]: {
    [JokerFieldShortNames.CHAR]: 2,
  },
  [JokerTypes.ITEM]: {
    [JokerFieldShortNames.CHAR]: 36,
    [JokerFieldShortNames.DATE]: 5,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 5,
  },
  [JokerTypes.PROJECT]: {
    [JokerFieldShortNames.CHAR]: 10,
    [JokerFieldShortNames.NUM]: 15,
    [JokerFieldShortNames.INT]: 5,
  },
  [JokerTypes.COMPLAINT]: {
    [JokerFieldShortNames.CHAR]: 5,
    [JokerFieldShortNames.DATE]: 5,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 5,
  },
  [JokerTypes.EMPLOYEE]: {
    [JokerFieldShortNames.CHAR]: 10,
    [JokerFieldShortNames.DATE]: 5,
    [JokerFieldShortNames.NUM]: 15,
    [JokerFieldShortNames.INT]: 5,
  },
  [JokerTypes.COMPANY]: {
    [JokerFieldShortNames.CHAR]: 10,
    [JokerFieldShortNames.DATE]: 5,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 5,
  },
  ...Object.fromEntries(
    Object.keys(DocumentType).map((key) => [
      key.toUpperCase(),
      {
        [JokerFieldShortNames.CHAR]: 10,
        [JokerFieldShortNames.DATE]: 5,
        [JokerFieldShortNames.NUM]: 5,
        [JokerFieldShortNames.INT]: 5,
        ROWS: {
          [JokerFieldShortNames.CHAR]: 10,
          [JokerFieldShortNames.DATE]: 5,
          [JokerFieldShortNames.NUM]: 5,
          [JokerFieldShortNames.INT]: 5,
        },
      },
    ])
  ),
};
